import type { ILighterBuildingFields, SanityBuilding } from '@metmuseum/types';
import { CLOISTERS_BUILDING_ID } from 'lib/constants.mjs';
import { routeForDocument } from '@metmuseum/routes';

// The Fifth Ave location is not equivalent to the Cloisters location, so get the url programmatically for now
const getBuildingUrl = (
	location: ILighterBuildingFields | SanityBuilding | { _id: string },
) => {
	if (location._id == CLOISTERS_BUILDING_ID) {
		return routeForDocument({
			_type: 'locationPage',
			slug: { current: 'met-cloisters' },
		});
	} else {
		return routeForDocument({ _type: 'planYourVisit' }); // Fifth ave, but also good failure state
	}
};

export default getBuildingUrl;
